// extracted by mini-css-extract-plugin
export default {"orBar":"DAph2hqD","choices":"_2NW-Ib1C","choice":"bSNToVUt","choiceWrapper":"_25Ad_UsP","choiceContent":"_2ZWUE4aU","paymentButtons":"_10jXd67k"};